import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

// Add font-face rule dynamically to avoid webpack CSS loader issues
const fontFaceStyle = document.createElement('style');
fontFaceStyle.textContent = `
  @font-face {
    font-family: 'Palestine';
    src: url('/Guesswhat-Exceptional.otf') format('opentype');
    font-weight: normal;
    font-style: normal;
    font-display: swap;
  }
`;
document.head.appendChild(fontFaceStyle);

// Preload font for better performance
const link = document.createElement('link');
link.rel = 'preload';
link.as = 'font';
link.type = 'font/otf';
link.crossOrigin = 'anonymous';
link.href = '/Guesswhat-Exceptional.otf';
document.head.appendChild(link);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

